<template>
  <div>
    <app-overlay-loader v-if="!dataLoaded"/>
    <div class="content-wrapper" :class="{ 'deal-closed': !dealStatus }" v-else>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <app-breadcrumb
              :page-title="formData.title"
              :directory="[$t('deals'), formData.title]"
              :icon="'clipboard'"
              :button="{ label: $t('back'), url: urlGenerator(`crm/deals/list/view`) }"
          />
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="float-md-right mb-3 mb-sm-3 mb-md-0" v-if="dealStatus">
            <button
                type="button"
                class="btn btn-primary btn-with-shadow"
                data-toggle="modal"
                @click="openSendProposalModal()"
            >
              {{ $t("send_proposal") }}
            </button>
          </div>
        </div>
      </div>

      <!--        deal contact person-->

      <deal-contact-person
          :dealPerson="formData"
          @update-deal="dealUpdateRequest"
      />

      <div class="row">
        <div class="col-xl-4 mb-primary">
          <app-deal-detail
              v-if="dataLoaded"
              :dealDetails="formData"
              :personList="personList"
              :statusList="statusList"
              :ownerList="ownerList"
              @update-deal="dealUpdateRequest"
          />
          <!--Deal details end-->

          <!--Person info start-->
          <app-deal-personal-info
              v-if="dataLoaded"
              :dealPersonalInfo="formData"
              :personList="personList"
              @update-deal="dealUpdateRequest"
          />

          <!--Person info end-->

          <!--Contact info start-->
          <app-deal-contact-info
              v-if="dataLoaded"
              :contactInfo="formData.person"
              :contactInfoDetails="formData"
              :personId="formData.person_id"
              @update-deal="dealUpdateRequest"
          />

          <!--Contact info end-->

          <!--Organization info start-->
          <app-deal-organization-info
              v-if="dataLoaded"
              :organizationinfo="formData"
              :ownerList="ownerList"
              @update-deal="dealUpdateRequest"
          />
          <!--Organization info end-->

          <app-deal-participation-info
              v-if="dataLoaded"
              :activityParticipations="groupByParticipant"
              @activity-list="updateActivity"
          />
          <!--Participation info end-->

          <!--Tags start-->

          <app-deal-tags
              class="mb-primary"
              :tagData="formData"
              :dealId="formData.id"
          />
          <!--Tags end-->

          <app-deal-activity-collaborator
              v-if="dataLoaded"
              :activityCollaborators="groupByCollaborator"
              @activity-list="updateActivity"
          />

          <!--Followers info start-->
          <deal-followers
              v-if="dataLoaded"
              :followerDeal="formData"
              :personList="personList"
              @update-deal="dealUpdateRequest"
          />
          <!--Followers info end-->
        </div>
        <div class="col-xl-8">
          <app-tab class="mb-primary" type="horizontal" :tabs="todoActivityTab" v-if="appTapShow"/>

          <div class="activity-filter-wrapper">
            <template v-for="(filter, index) in activitiesFilter">
              <button
                  class="btn btn-sm px-3 rounded-pill primary-card-color mr-2"
                  :class="[
                            value === filter.key
                            ? 'text-primary'
                            : index === 0 && value === ''
                            ? 'text-primary'
                            : 'text-muted',]"
                  @click.prevent="dealActivitiesFilter(filter.key)">
                {{ filter.name }}
              </button>
            </template>

            <div class="mt-2 activity-filtered-result-wrapper">
              <template v-if="preLoader"></template>
              <template v-else>
                <template v-if="activitiesList.length < 1">
                  <div class="card card-with-shadow border-0">
                    <div class="card-body">
                      <template v-for="filter in activitiesFilter">
                        <app-empty-data-block
                            v-if="value === filter.key"
                            :key="filter.key"
                            :message="$t('please_add_something_in') + filter.name"
                        />
                      </template>
                    </div>
                  </div>
                </template>
                <div
                    v-else
                    :class="{ 'mb-2': activitiesList.length > 0 }"
                    v-for="(activity, index) in activitiesList"
                    :key="index"
                >
                  <div class="card card-with-shadow border-0">
                    <div class="card-body">
                      <div class="d-flex justify-content-between mb-3">
                        <div class="d-flex align-items-center">
                          <div
                              class="d-flex align-items-center justify-content-center primary-text-color mr-2 activity-icon"
                          >
                            <app-icon stroke-width="1" :name="activity.icon"/>
                          </div>
                          <div>
                            <h6 v-if="activity.title">{{ activity.title }}</h6>
                            <h6 v-if="activity.path">
                              {{ activity.path.split("/").pop() }}
                            </h6>
                            <h6 v-if="activity.note">
                              {{ textTruncate(activity.note, 15) }}
                            </h6>
                            <div class="d-flex align-items-center font-size-70">
                              <label
                                  v-if="activity.status_id == 9"
                                  class="customized-radio mini radio-default mr-0"
                              >
                                <input
                                    type="radio"
                                    :disabled="$can('update_activities') && $can('done_activities') ? false : true"
                                    class="radio-inline"
                                    @click="activityChangeStatus(activity.id)"
                                />
                                <span class="outside">
                                  <span class="inside"/>
                                </span>
                              </label>

                              <div
                                  v-if="activity.started_at"
                                  class="text-success"
                              >
                                <span
                                    v-if="activity.started_at == today.dateOnly"
                                >
                                  {{ $t("today") }} | {{ onlyTimeFromTime(activity.started_at, activity.start_time) }}
                                </span>
                                <span
                                    v-else-if="activity.ended_at < today.dateOnly"
                                >
                                  {{ $t("yesterday") }} |
                                  {{ onlyTimeFromTime(activity.started_at, activity.start_time) }}
                                </span>
                                <span v-else>
                                  {{
                                    formatDateToLocal(activity.started_at, true, activity.start_time)
                                  }} | {{ formatDateToLocal(activity.ended_at, true, activity.end_time) }}
                                </span>
                              </div>

                              <div v-else class="text-success">
                                <span
                                >{{ formatDateToLocal(activity.created_at) }} | {{ onlyTime(activity.created_at) }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                            v-if="activity.status_id == 9 && (($can('update_activities') && $can('done_activities')) || $can('delete_activities'))"
                            class="dropdown options-dropdown"
                        >
                          <button
                              type="button"
                              class="btn-option btn"
                              data-toggle="dropdown"
                          >
                            <app-icon name="more-vertical"/>
                          </button>
                          <div
                              class="dropdown-menu dropdown-menu-right py-2 mt-1 text-muted"
                          >
                            <a
                                v-if="$can('update_activities') && $can('done_activities')"
                                class="dropdown-item font-size-80 px-4 py-2"
                                href="#"
                                @click.prevent="editActivity(activity)"
                            >{{ $t("edit") }}</a
                            >
                            <a
                                v-if="$can('done_activities')"
                                class="dropdown-item font-size-80 px-4 py-2"
                                href="#"
                                @click.prevent="activityChangeStatus(activity.id)"
                            >{{ $t("mark_as_done") }}</a
                            >
                            <a
                                v-if="$can('delete_activities')"
                                class="dropdown-item font-size-80 px-4 py-2"
                                href="#"
                                @click.prevent="activityDelete(activity.id)"
                            >{{ $t("delete") }}</a
                            >
                          </div>
                        </div>

                        <div
                            v-if="activity.path"
                            class="dropdown options-dropdown"
                        >
                          <button
                              type="button"
                              class="btn-option btn"
                              data-toggle="dropdown"
                          >
                            <app-icon name="more-vertical"/>
                          </button>
                          <div
                              class="dropdown-menu dropdown-menu-right py-2 mt-1 text-muted"
                          >
                            <a
                                class="dropdown-item font-size-80 px-4 py-2"
                                href="#"
                                @click.prevent="fileDownload(activity)"
                            >{{ $t("download") }}</a
                            >
                          </div>
                        </div>

                        <div
                            v-if="activity.note"
                            class="dropdown options-dropdown"
                        >
                          <button
                              type="button"
                              class="btn-option btn"
                              data-toggle="dropdown"
                          >
                            <app-icon name="more-vertical"/>
                          </button>
                          <div
                              class="dropdown-menu dropdown-menu-right py-2 mt-1 text-muted"
                          >
                            <a
                                class="dropdown-item font-size-80 px-4 py-2"
                                href="#"
                                @click.prevent="editNote(activity)"
                            >{{ $t("edit") }}</a
                            >
                            <a
                                class="dropdown-item font-size-80 px-4 py-2"
                                href="#"
                                @click.prevent="noteDelete(activity.id)"
                            >{{ $t("delete") }}</a
                            >
                          </div>
                        </div>
                      </div>
                      <div
                          v-if="activity.note"
                          class="note p-4 note-warning mb-3">
                        <p class="m-1">{{ textTruncate(activity.note, 60) }}</p>
                      </div>

                      <div class="mb-3 d-flex flex-wrap align-items-center">
                        <div
                            class="d-flex align-items-center mr-3"
                            v-if="formData.owner"
                        >
                          <app-avatar
                              class="mr-2"
                              :title="formData.owner.first_name"
                              :avatar-class="'avatars-w-20'"
                              :img="
                              formData.owner.profile_picture
                                ? formData.owner.profile_picture.path
                                : formData.owner.profile_picture
                            "
                          />
                          <span class="text-muted font-size-90">{{
                              formData.owner.full_name
                            }}</span>
                        </div>
                        <div
                            class="d-flex align-items-center mr-3"
                            v-if="formData.person"
                        >
                          <span class="mr-2 text-secondary person-icon"
                          ><app-icon :name="'user'"></app-icon
                          ></span>
                          <span class="text-muted font-size-90">{{
                              formData.person.name
                            }}</span>
                        </div>
                        <div
                            class="d-flex align-items-center mr-3"
                            v-if="formData.organization"
                        >
                          <span class="mr-2 text-secondary org-icon"
                          ><app-icon :name="'briefcase'"></app-icon
                          ></span>
                          <span class="text-muted font-size-90">{{
                              formData.organization.name
                            }}</span>
                        </div>
                      </div>

                      <div v-if="isfileNoteFilter">
                        <p v-if="activity.participants.length"
                           class="d-flex flex-wrap align-items-center">
                          {{ $t("participants:") }}
                        </p>
                        <div v-bind:class="{'mb-3': activity.collaborators.length > 0,}"
                             class="d-flex flex-wrap align-items-center">
                          <div
                              class="mb-1 d-flex align-items-center mr-3"
                              v-for="participant in participants"
                              v-if="activity.id == participant.pivot.activity_id"
                          >
                            <app-avatar
                                :title="participant.name"
                                class="mr-2"
                                :avatar-class="'avatars-w-20'"
                                :img="''"
                            />
                            <span class="text-muted font-size-90">{{
                                participant.name
                              }}</span>
                          </div>
                        </div>
                        <p v-if="activity.collaborators.length"
                           class="d-flex flex-wrap align-items-center">
                          {{ $t("collaborators:") }}
                        </p>
                        <div class="d-flex flex-wrap align-items-center">
                          <div
                              class="d-flex align-items-center mr-3"
                              v-for="collaborator in collaborators"
                              v-if="activity.id == collaborator.pivot.activity_id"
                          >
                            <app-avatar
                                :title="collaborator.full_name"
                                class="mr-2"
                                :avatar-class="'avatars-w-20'"
                                :img="''"
                            />
                            <span class="text-muted font-size-90">{{
                                collaborator.full_name
                              }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!--Send Proposal Modal-->
      <app-modal
          v-if="isSendProposalModalActive"
          modal-id="send-proposal"
          modal-size="default"
          modal-alignment="top"
          @close-modal="closeSendProposalModal"
      >
        <template slot="header">
          <h5 class="modal-title">{{ $t("send_proposal") }}</h5>
          <button
              type="button"
              class="close outline-none"
              data-dismiss="modal"
              aria-label="Close"
          >
            <span>
              <app-icon :name="'x'"/>
            </span>
          </button>
        </template>
        <template slot="body">
          <template v-if="formData.person && formData.person.email[0]">
            <h5 class="primary-text-color mb-2">
              {{ $t("great_exclamation") }}
            </h5>
            <h6 class="text-muted mb-4">
              {{ $t("you_are_going_to_send_a_proposal") }}
            </h6>
            <div class="form-group">
              <app-input
                  type="radio"
                  :custom-radio-type="'d-block mb-3'"
                  :list="proposalSendingTypeList"
                  v-model="proposalSendingType"
                  @click="proposalDealIdStore(formData.id)"
              />
            </div>
            <div
                v-if="proposalSendingType === 'send_quick_proposal'"
                class="form-group mb-0"
            >
              <app-input
                  type="select"
                  list-value-field="subject"
                  :list="templateList"
                  :placeholder="$t('choose_one_and_confirm')"
                  v-model="proposalChoseType"
              />
            </div>
          </template>
          <template v-else>
            <template v-if="!formData.person">
                <div class="d-flex h-100 align-items-center">
                    <app-note class="w-100" padding-class="p-2" title="'send'" :show-title="false" :notes="[$t('the_deal_has_no_contact_person_with_email')]"/>
                </div>
            </template>
            <template v-else>
                <div class="d-flex h-100 align-items-center">
                    <app-note class="w-100" padding-class="p-2" title="'send'" :show-title="false" content-type="html" :notes='noteMessage'/>
                </div>
            </template>
          </template>
        </template>
        <template slot="footer">
          <button
              v-if="formData.person && formData.person.email[0]"
              type="button"
              class="btn btn-secondary mr-2"
              data-dismiss="modal"
          >
            {{ $t("cancel") }}
          </button>
          <button
              type="button"
              v-if="formData.person && formData.person.email[0]"
              @click.prevent="proposalSendMail()"
              class="btn btn-primary"
          >
            {{ $t("confirm") }}
          </button>
          <button
              type="button"
              v-else
              data-dismiss="modal"
              class="btn btn-lg btn-primary"
          >
            {{ $t("ok") }}
          </button>
        </template>
      </app-modal>

      <app-deal-activities-modal
          v-if="dealActivitiesModal"
          :activity="rowData"
          :selected-url="editedUrl"
          @close-modal="closeDealActivitiesModal"
      />

      <app-common-note-modal
          v-if="dealNoteModal"
          :note="noteRowData"
          @close-modal="closeDealNoteModal"
      />
    </div>
  </div>
</template>

<script>
import {FormMixin} from "@core/mixins/form/FormMixin";
import {formatDateToLocal, textTruncate, onlyTime, onlyTimeFromTime, urlGenerator} from "@app/Helpers/helpers";
import {mapGetters} from "vuex";
import ActivityMixin from "@app/Mixins/Global/ActivityMixin";
import {api} from "@app/Helpers/api";
import {collect} from "@app/Helpers/Collection";

export default {
  name: "DealDetails",
  mixins: [FormMixin, ActivityMixin],
  data() {
    return {
      textTruncate,
      onlyTimeFromTime,
        urlGenerator,
      preLoader: false,
      isfileNoteFilter: true,
      dataLoaded: false,
      formData: {},
      activitiesList: [],
      editedUrl: "",
      today: {dateOnly: moment(new Date()).format("YYYY-MM-DD")},
      endTime: {},
      isSendProposalModalActive: false,
      appTapShow: false,
      proposalChoseType: "",
      proposalSendingType: "",
      dealActivitiesModal: false,

      proposalSendingTypeList: [
        {
          id: "send_proposal_with_new_template",
          value: "With new template",
        },
        {
          id: "send_quick_proposal",
          value: "Or want to send a quick proposal",
        },
      ],

      // Tab Start
      todoActivityTab: [
        {
          name: "activity",
          icon: "activity",
          component: "deal-activity-tab",
          props: "",
          permission: "",
        },
        {
          name: "file",
          icon: "paperclip",
          component: "deal-file-tab",
          props: "",
          permission: "",
        },
        {
          name: "note",
          icon: "file-text",
          component: "deal-note-tab",
          props: "",
          permission: "",
        },
      ],

      dealNoteModal: false,
      noteRowData: null,
      value: "",
      groupByCollaborator: [],
      collaborators: [],
      groupByParticipant: [],
      participants: [],
      status_id: 7,
      formatDateToLocal,
      onlyTime,
    };
  },
  computed: {
    ...mapGetters({
      ownerList: "getOwner",
      statusList: "getStatus",
      personList: "getPerson",
      templateList: "getTemplate",
    }),

    dealStatus() {
      return (
          this.formData.status.name == "status_open" &&
          this.formData.status.type == "deal"
      );
    },
      noteMessage() {
        let url = urlGenerator(`crm/persons/${this.formData.person.id}/edit`);
        return `
            ${this.$t("the_contact")}
            <a class="alert-link" href="${url}">
                ${this.formData.person.name}
            </a>
            ${this.$t("belongs_to_the_deal_has_no_email")}
        `;
      }
  },
  methods: {
    afterSuccessFromGetEditData(response) {
      let collaborator = [];
      let participant = [];
      this.formData = response.data;

      // Collaborator Group by
      this.formData.activity.forEach((element, index) => {
        element.collaborators.forEach((item, index) => {
          collaborator.push(item);
        });
      });
      this.groupByCollaborator = _.groupBy(collaborator, "id");
      this.collaborators = collaborator;

      // Participant Group By
      this.formData.activity.forEach((element, index) => {
        element.participants.forEach((item, index) => {
          participant.push(item);
        });
      });
      this.groupByParticipant = _.groupBy(participant, "id");
      this.participants = participant;

      this.todoActivityTab.forEach((el) => {
        el["props"] = {
          id: this.formData.id,
          status: this.dealStatus,
        };
      });
      this.appTapShow = true;
      this.dealActivitiesFilter("status=9");
      this.dataLoaded = true;
    },
    dealUpdateRequest() {
      let collaborator = [];
      let participant = [];

      this.collaborators = [];
      this.participants = [];

      this.axiosGet(this.selectedUrl)
          .then(({data}) => {
            this.formData = data;

            //Reload tab to send deal update status
            this.appTapShow = false;
            this.todoActivityTab.forEach((el) => {
              el["props"] = {
                id: this.formData.id,
                status: this.dealStatus,
              };
            });

            setTimeout(() => {
              this.appTapShow = true;
            });


            // Collaborator Group by
            this.formData.activity.forEach((element, index) => {
              element.collaborators.forEach((item, index) => {
                collaborator.push(item);
              });
            });
            this.groupByCollaborator = _.groupBy(collaborator, "id");
            this.collaborators = collaborator;

            // Participant Group By
            this.formData.activity.forEach((element, index) => {
              element.participants.forEach((item, index) => {
                participant.push(item);
              });
            });
            this.groupByParticipant = _.groupBy(participant, "id");
            this.participants = participant;
          })
          .catch((error) => console.log(error));
    },
    updateTagList() {
      this.$hub.$on("tag-list", (value = true) => {
        if (value) {
          this.dealUpdateRequest();
        }
      });
    },

    openSendProposalModal() {
      this.isSendProposalModalActive = true;
    },

    dealActivitiesFilter(key) {
      this.preLoader = true;
      this.value = key;
      if (key == "file" || key == "note") {
        this.isfileNoteFilter = false;
        this.axiosGet(`crm/deal/${this.formData.id}/${key}`)
            .then((response) => {
              this.activitiesList = response.data;
            })
            .finally(() => {
              this.preLoader = false;
            })
            .catch((error) => console.log(error));
      } else {
        this.isfileNoteFilter = true;
        this.axiosGet(`crm/deal/activities/${this.formData.id}?${this.value}`)
            .then((response) => {
              this.activitiesList = response.data;
            })
            .finally(() => {
              this.preLoader = false;
            })
            .catch((error) => console.log(error));
      }
    },
    updateActivity() {
      this.$hub.$on("activity-list", (value = true) => {
        if (value) {
          this.dealUpdateRequest();
          this.dealActivitiesFilter("status=9");
        }
      });
    },
    activityChangeStatus(id) {
      this.axiosPost({
        url: `crm/activities/done/${id}`,
      })
          .then((response) => {
            this.$toastr.s(response.data.message);
            this.dealActivitiesFilter("status=9");
          })
          .catch((error) => console.log(error));
    },
    activityDelete(id) {
      this.axiosDelete(`crm/activities/${id}`)
          .then((response) => {
            this.$toastr.e(response.data.message);
            this.dealActivitiesFilter("status=9");
          })
          .catch((error) => console.log(error));
    },
    editActivity(activity) {
      this.dealActivitiesModal = true;
      this.editedUrl = `crm/activities/${activity.id}`;
      this.rowData = activity;
    },
    editNote(activity) {
      this.dealNoteModal = true;
      this.noteRowData = activity;
      setTimeout(() => {
        $("#note-modal").modal("show");
      });
    },
    noteDelete(id) {
      this.axiosDelete(`crm/note/delete/${id}`)
          .then((response) => {
            this.$toastr.e(response.data.message);
            this.dealActivitiesFilter("note");
          })
          .catch((error) => console.log(error));
    },
    closeDealActivitiesModal() {
      this.dealActivitiesModal = false;
      $("#deal-activity-modal").modal("hide");
    },
    closeDealNoteModal() {
      this.dealNoteModal = false;
      $("#note-modal").modal("hide");
    },
    proposalSendMail() {
      api
          .route("crm/statuses")
          .params({name: "status_sent", type: "proposal"})
          .get("id")
          .then((res) => {
            this.formData.status_id = collect(res).first().id;
            let pipelineStatusId = collect(res).first().id;

            if (this.proposalSendingType == "send_quick_proposal") {
              this.axiosPost({
                url:`crm/send-deal-person-proposal`,
                data: {
                  proposal_choice_type: this.proposalChoseType,
                  deal_id: Number(this.formData.id),
                  status_id: pipelineStatusId,
                },
              }).then((response) => {
                this.closeSendProposalModal();
                if (response.data.message) {
                  this.$toastr.s(response.data.message);
                } else {
                  this.$toastr.e(response.data.error);
                }
              });
            } else {
              window.location.replace(urlGenerator("crm/proposals/create"));
            }
          });
    },
    closeSendProposalModal() {
      this.isSendProposalModalActive = false;
      $("#send-proposal").modal("hide");
    },
    proposalDealIdStore(id) {
      this.$store.dispatch("setProposalDealId", id);
    },
  },
  mounted() {
    this.updateActivity();
    this.updateTagList();
    this.$store.dispatch("getPerson");
    this.$store.dispatch("getStatus");
    this.$store.dispatch("getOwner");
    this.$store.dispatch("getTemplate");
  },
};
</script>
<style>
.deal-closed .step-input {
  opacity: 0.5;
  cursor: not-allowed;
}

.deal-closed .step-input:hover {
  opacity: 0.8;
}
</style>
